// localStorage 工具
const PREFIX = 'baby-log:'

export const storage = {
  get<T>(key: string): T | null {
    try {
      const v = localStorage.getItem(PREFIX + key)
      return v ? JSON.parse(v) : null
    } catch {
      return null
    }
  },

  set(key: string, value: unknown): void {
    try {
      localStorage.setItem(PREFIX + key, JSON.stringify(value))
    } catch (e) {
      console.warn('Storage write failed', e)
    }
  },

  remove(key: string): void {
    try {
      localStorage.removeItem(PREFIX + key)
    } catch {
      // ignore
    }
  },

  clearAll(): void {
    try {
      Object.keys(localStorage)
        .filter((k) => k.startsWith(PREFIX))
        .forEach((k) => localStorage.removeItem(k))
    } catch {
      // ignore
    }
  },
}
